const SearchSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13 13.001L11.0556 11.0565M10.7778 6.88987C10.7778 7.40056 10.6772 7.90626 10.4818 8.37808C10.2863 8.8499 9.99987 9.27861 9.63875 9.63973C9.27763 10.0008 8.84892 10.2873 8.3771 10.4827C7.90528 10.6782 7.39959 10.7788 6.88889 10.7788C6.37819 10.7788 5.8725 10.6782 5.40068 10.4827C4.92885 10.2873 4.50015 10.0008 4.13903 9.63973C3.77791 9.27861 3.49146 8.8499 3.29602 8.37808C3.10059 7.90626 3 7.40056 3 6.88987C3 5.85847 3.40972 4.86931 4.13903 4.14001C4.86834 3.4107 5.85749 3.00098 6.88889 3.00098C7.92029 3.00098 8.90944 3.4107 9.63875 4.14001C10.3681 4.86931 10.7778 5.85847 10.7778 6.88987Z"
        stroke="#333333"
        strokeWidth="1.07317"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SearchSvg;
